import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { getToken } from 'src/auth';
import { FIsTab } from '../components/FIsTab';
import { fetchFIMetrics } from '../services/reportingApi';

function FIsPageComponent({ token }) {
  const { dateRange } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fiMetrics, setFiMetrics] = useState([]);

  useEffect(() => {
    if (token && dateRange) {
      loadMetrics();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, token]);

  async function loadMetrics() {
    setLoading(true);
    setError(null);

    try {
      const params = {};
      if (dateRange && dateRange[0]) {
        params.start_date = dateRange[0].toISOString().split('T')[0];
      }
      if (dateRange && dateRange[1]) {
        params.end_date = dateRange[1].toISOString().split('T')[0];
      }

      const fis = await fetchFIMetrics(params, token.accessToken);
      setFiMetrics(Array.isArray(fis) ? fis : []);
    } catch (err) {
      console.error('Failed to load FI metrics:', err);
      setError(err.message || 'Failed to load FI metrics');
    } finally {
      setLoading(false);
    }
  }

  if (loading && fiMetrics.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3 }}>
        {error}
      </Alert>
    );
  }

  return <FIsTab fiMetrics={fiMetrics} />;
}

const mapStateToProps = (state) => ({
  token: getToken(state),
});

export const FIsPage = connect(mapStateToProps)(FIsPageComponent);
